import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

class SelectPreferredLanguagesAction extends BaseAction<void, { language: string, router: any }> {
    override async run(): Promise<void> {
        try {
            const { language } = this.params!
            updateRecoilState("languageDropdownOpenAtom", false)
            updateRecoilState("localeLanguageAtom", language)
            document.cookie = `LOCALE=${encodeURIComponent(language)}; path=/; max-age=31536000; SameSite=Lax`;
            // Full reload so all locale-dependent client-fetched CMS data (Enhance Your Trip,
            // Popular Trips, Useful Information, Offers, etc.) is re-fetched in the new locale.
            // router.refresh() only re-runs SSR and leaves jotai atoms with stale strings.
            window.location.reload();
        } catch (error: any) {
            console.error("Error fetching language:", error);
        }
    }
}

export const selectPreferredLanguagesAction = new SelectPreferredLanguagesAction()


